import React from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function EducationSection({ form, setForm }) {
  const handleChange = (index, field, value) => {
    const updated = [...form.educations];
    updated[index][field] = value;
    setForm({ ...form, educations: updated });
  };

  const handleAdd = () => {
    setForm({
      ...form,
      educations: [
        ...form.educations,
        {
          institution: "",
          degree: "",
          field: "",
          graduation_date: "",
        },
      ],
    });
  };

  const handleRemove = (index) => {
    const updated = form.educations.filter((_, i) => i !== index);
    setForm({ ...form, educations: updated });
  };

  return (
    <Box className="candidate-section">
      <Box className="candidate-section-head">
        <Typography className="candidate-section-kicker">Section 3</Typography>
        <Typography className="candidate-section-title">Education</Typography>
        <Typography className="candidate-section-subtitle">
          Track academic history relevant to role requirements.
        </Typography>
      </Box>

      {form.educations.length === 0 ? (
        <Box className="candidate-empty-state">
          <Typography>No education records added yet.</Typography>
        </Box>
      ) : null}

      {form.educations.map((edu, index) => (
        <Box key={index} className="candidate-entry-card">
          <Box className="candidate-entry-top">
            <Typography className="candidate-entry-title">
              Education {index + 1}
            </Typography>
            <IconButton
              type="button"
              onClick={() => handleRemove(index)}
              className="candidate-remove-btn"
            >
              <DeleteIcon />
            </IconButton>
          </Box>

          <Box className="candidate-grid two-col">
            <TextField
              fullWidth
              label="Institution"
              value={edu.institution}
              onChange={(e) => handleChange(index, "institution", e.target.value)}
            />
            <TextField
              fullWidth
              label="Degree"
              value={edu.degree}
              onChange={(e) => handleChange(index, "degree", e.target.value)}
            />
            <TextField
              fullWidth
              label="Field of Study"
              value={edu.field}
              onChange={(e) => handleChange(index, "field", e.target.value)}
            />
            <TextField
              fullWidth
              label="Graduation Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={edu.graduation_date}
              onChange={(e) =>
                handleChange(index, "graduation_date", e.target.value)
              }
            />
          </Box>
        </Box>
      ))}

      <Button type="button" variant="outlined" onClick={handleAdd} className="candidate-add-btn">
        Add Education
      </Button>
    </Box>
  );
}
